//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Illustration, Typography } from '@backmarket/design-system'

import translations from './500.translations'

export default {
  components: {
    Illustration,
    Typography,
  },
  props: {
    error: {
      type: Object,
      required: true,
    },
  },
  computed: {
    translations: () => translations,
  },
}
